import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';

import { Link } from 'core/routing';

import { Div } from 'legacyComponents/styled/lib';
import { Avatar } from 'apps/components/shared';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import {
  SmallCard as Card,
  SmallCardTextWrapper,
  FullWidthTitle,
  FullWidthDescription,
} from 'legacyComponents/cards/styles';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

@withNamespaces()
@observer
export class SmallProfileCard extends React.Component {
  render() {
    const { cardObject, cardNo, cardColumns } = this.props;

    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='contributor' />;
    }
    const {
      avatar,
      imageFallbackPath,
      fullName,
      username,
      content,
    } = cardObject;
    return (
      <Card noMargin={noMargin}>
        <Div position='relative' display='block'>
          <Link name='profile' params={{ profile: username }} content={content}>
            <ProfileAvatar
              src={imageSrc(
                avatar,
                imageFallbackPath,
                mainConf.imgSizes.profile.small,
              )}
            />
          </Link>
        </Div>
        <TextWrapper>
          <Link name='profile' params={{ profile: username }} content={content}>
            <Title>{fullName}</Title>
          </Link>
          <Description>
            <Link
              name='profile'
              params={{ profile: username }}
              content={content}
            >
              {username}
            </Link>
          </Description>
        </TextWrapper>
      </Card>
    );
  }
}

const ProfileAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0px;
`;

const TextWrapper = styled(SmallCardTextWrapper)`
  margin-left: 50px;
  margin-right: 0px;
`;

const Title = styled(FullWidthTitle)`
  &:hover {
    color: ${props => props.theme.color.primary};
  }
`;

const Description = styled(FullWidthDescription)`
  font-weight: 600;
  color: ${props => props.theme.color.primary};
  > a {
    color: ${props => props.theme.color.primary};
  }
`;

SmallProfileCard.propTypes = {
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardNo: PropTypes.number,
};
